export default __webpack_public_path__ + "static/media/weekly_questions_icon.2137f2aa.svg";